import styled from 'styled-components';

export const BookmarkContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  cursor: pointer;
  color: ${props => props.color || 'var(--neutral-text-color)'};
  > svg path {
    fill: ${props => props.color || 'var(--neutral-text-color)'};
  }
  > svg {
    top: ${props => props.top || '4'}px;
    right: ${props => props.right || '0'}px;
  }
  > div {
    margin-left: 8px;
  }
`;
